<template>
    <div class="nav-menu" v-if="showMenu">
        <div class="nav-menu-body">
            <div :class="{
                'menu-item':true,
                'sel-color':selectMenu == item.key_name,
                'nsel-color':selectMenu!=item.key_name,
                'pointer':true
            }" v-for="item in navList" :key="item.category" @click="clickMenu(item.key_name)">
                <div>{{item.key_name}}</div>
            </div>
        </div>
        <div class="mask" @click="closeMask"></div>
    </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { getClassList } from "@/api/games"

    export default {
        data() {
            return {
                navList:[],
                selectMenu:'Hot',
                showMenu:false,
            }
        },
        mounted() {
            eventBus.$on('showmenu',i=>{                
                this.showMenu = i;
            })
            this.getclasslist();
        },
        methods: {
            async getclasslist(){
                this.navList = await getClassList();
            },
            closeMask(){
                this.showMenu = false;
                eventBus.$emit('showfenlei',false);
            },
            clickMenu(item){
                this.showMenu = false;
                eventBus.$emit('showfenlei',false);
                this.selectMenu = item;
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                if(this.$route.path=='/selectGame'){
                    eventBus.$emit('searchgame',{
                        id:'more',
                        key:item
                    });
                }else{
                    this.$router.push({
                        path: '/selectGame',
                        query:{
                            id:'more',
                            key:item
                        }
                    })
                }
            }
        },
    }
</script>

<style lang="less" scoped>
@media (min-width: 768px) {
  .nav-menu{
    width: 1200px;
  }
}
@media (max-width: 768px) {
  .nav-menu{
    width: 100%;
  }
}
.pointer{
    cursor: pointer;
}
.nav-menu{
    position: fixed;
    top: 50px;
    z-index: 99999;
    .nav-menu-body{
        &::-webkit-scrollbar{
            display: none;
        }
        height: 315px;
        background: #FAEDB8;
        border-radius: 1px;
        overflow: auto;
        .sel-color{
            color: #D8C8B1;
        }
        .nsel-color{
            color: #373952;
        }
        .menu-item{
            margin: 0 auto;
            width: 315px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            line-height: 39px;
            text-align: center;
            font-style: normal;
            border-bottom: 1px solid #E7E7E7;
        }
    }
    .mask{
        height: calc(100vh - 365px);
        background: rgba(0, 0, 0, 0.5);

    }
}
</style>